import './App.css';
import { FooterDet } from './components/Footer';
import IntroductionComp from './components/Introduction';
import Navbar from './components/Navbar';
import ProjectShowcase from './components/ProjectShowcase';
import { Skills } from './components/Skills';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Contact } from './components/Contact';
import "animate.css/animate.min.css";
import { createTheme } from '@material-ui/core';
import { ThemeProvider } from '@mui/material';

function App() {
  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1400,
        xl: 1536,
      },
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={
            <div className="App">
              <Navbar />
              <ProjectShowcase />
              <IntroductionComp />
              <Skills />
              <FooterDet />
            </div >} />
          <Route path="contact" element={
            <div className='App' style={{ overflow: "hidden" }}>
              <Navbar />
              <Contact />
              <FooterDet />
            </div>} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>

  );
}

export default App;
